import React, { useEffect, useRef, useState } from "react";
// import { FooterComponents } from "../../components/FooterComponents/FooterComponents";
//import './HomePageScreen.css';
// import 'primeflex/primeflex.css';
// import { Card } from 'primereact/card';
// import { Carousel } from 'primereact/carousel'
import { useParams, useLocation, useHistory  } from "react-router-dom";
import { Breadcrumb, Layout, Menu, Button, PageHeader, Row, Col, Form, Input, Select, Skeleton, notification, Checkbox,Space, Collapse,DatePicker, Modal, message } from 'antd';

import { ECatalogNavigation } from "../../components/ECatalogComponents/ECatalogNavigation";
import "./ProductDetailScreen.css";
import { BsCartPlus, BsTrash } from "react-icons/bs";
import { Item, useCart } from "react-use-cart";
import { SearchCatalogItem, GetWolfTemplate, CreateMemorandum, InsertTransactionOrderitem, GetSellerById, GetBudget, ReceiveAddress, SetBudget, GetBudgetByEmpCode, GetECatalogCostcenter, GetCostcenterBudgetByCode} from "../../Services/EcatalogService";
import { IProductItem } from "../../IRequestModel/ECatalog/IProductItemModel";
import type { CheckboxProps } from 'antd';
import { useUserContext } from "../../Context/UserContext";
import { GetFiscalYear, MapsDataToProductObject, NotificationAddCartSuccess, NumberFormatter } from "../../Helper/ECatalogHelper";
import Swal from 'sweetalert2'
import { useECatalogContext } from "../../Context/ECatalogContext";
import moment from "moment";
import 'moment/locale/th';
import UnAurthorization from "../UnAuthorizePage/UnAurthorization";
import { GetMasterDataByTypeNames } from "../../Services/MasterDataService";
import { generateQuickGuid } from "../../Helper/GenerateGuid";
import useAlert from "../../hooks/useAlert";

interface Props { responeConfig?: { pathLoading?: string } }
const { Header, Content, Footer, Sider  } = Layout;
const { Option } = Select;

const layout = {
    labelCol: { span: 4 },
    wrapperCol: { span: 10 },
};
const tailLayout = {
    wrapperCol: { offset: 4, span: 10 },
};
const { Panel } = Collapse;
const { TextArea } = Input;
const { Search } = Input;
type SummaryData = {
    TotalPrice: number,
    TotalPriceNoVat: number,
    VatPrice: number,
    TotalQuantity: number,
}
type FormReceiveProps = {
    ReceiveName?: any;
    Telephone?: any;
    ReceiveDate?: any;
    ReceiveLocation?: any;
    EmployeeCode?: any;
  };
type ProductParams = {
    productId: string;
    // isAutoReport: string;
  };
  type NotificationType = 'success' | 'info' | 'warning' | 'error';
export const CartScreen = (props: Props) => {
    const [userData, setUserData] = useUserContext();
    const { toggleAlert } = useAlert();
    const checkEcatalog = useECatalogContext();
    const [productqty, setProductqty] = useState<number>(1);
    const [productItems, setProductItems] = useState<Item[]>();
    const [summaryData, setSummaryData] = useState<SummaryData>({
        TotalPrice: 0,
        TotalPriceNoVat: 0,
        TotalQuantity: 0,
        VatPrice: 0
    });
    const [collapseKey, setCollapseKey] = useState<number>(0);
    const query = new URLSearchParams(useLocation().search);
    const [isCardLoading, setIsCardLoading] = useState<boolean>(false);
    const [openSummaryOrderPopup, setOpenSummaryOrderPopup] = useState(false);
    const [checkAll, setCheckAll] = useState(true);
    const [form] = Form.useForm();
    const [formReceive, setFormReceive] = useState<FormReceiveProps>();
    const [addProductId, setAddProductId] = useState<string>("");
    const [loadingsAddProduct, setLoadingsAddProduct] = useState<boolean>(false);
    const [loadingsSendOrder, setLoadingsSendOrder] = useState<boolean>(false);
    const [userBudget, setUserBudgetSelect] = useState<any>({Remaining: 400000});
    const [userBudgetData, setUserBudgetData] = useState<any>();
    const [userBudgetOption, setUserBudgetOption] = useState<any>();
    const [receiverAddress, setReceiverAddress] = useState<any>();
    const [receiverAddressOption, setReceiverAddressOption] = useState<any>();
    const [isAuthorize, setIsAuthorizeo] = useState(true);
    const [isEditECatalog, setIsEditECatalog] = useState(true);
    const [costCenterDataLoading, setCostCenterDataLoading] = useState<boolean>(false);
    const [costCenterData, setCostCenterData] = useState<any>();
    const [costCenterOption, setCostCenterOption] = useState<any>();
    const [departmentData, setDepartmentData] =useState<any>();
    const [costCenterBudgetData, setCostCenterBudgetData] =useState<any>();
    const [costCenterBudget001Option, setCostCenterBudget001Option] =useState<any>();
    const [costCenterBudget002Option, setCostCenterBudget002Option] =useState<any>();
    const [costCenterBudget003Option, setCostCenterBudget003Option] =useState<any>();
    const [branchOption, setBranchOption]=useState<any>();
    const [costcenterSelected, setCostcenterSelected] = useState<any>();
    const [costcenterRequired, setCostcenterRequired] = useState(false);
    const [internalOrderData, setInternalOrderData] = useState<any>();
    const [validateClick, setValidateClick] = useState<boolean>(false);
    const [branchDataLoading, setBranchDataLoading] = useState<boolean>(false);
    const history = useHistory();
    const {
        isEmpty,
        totalUniqueItems,
        items,
        updateItemQuantity,
        removeItem,
        totalItems,
        addItem
    } = useCart();
    useEffect(() => {
        if (checkEcatalog.roleData  != null)
        {
            setIsAuthorizeo(checkEcatalog.canAccess);
            setIsEditECatalog(checkEcatalog.canEdit);
        }
        console.log(checkEcatalog);
    }, [checkEcatalog]);
    useEffect(() => {
        //  const updatedItem = items.map((item) => {
        //         return { ...item, ...{checkItem: checkAll, budgetAmount: 0} };
        //   });

        // setProductItems(updatedItem);
        // processSummary(updatedItem);
        //   if (updatedItem.filter(x => x.checkItem).length > 0)
        //     setCollapseKey(1);
        //   else
        //   setCollapseKey(0);
        updateProductItemState();

        let defaultReceive : FormReceiveProps = {
            ReceiveName: userData.NameTh,
            Telephone: "",
            ReceiveDate: "",
            ReceiveLocation: ""
        }
        //getBudget();
        getCostcenter();
        //getListOfBudgetByEmpCode();
        //getReceiverAddress();
        //setFormReceive(defaultReceive);
    }, []);
    useEffect(() =>{
        updateProductItemState(); 
    }, [items])

    useEffect(() =>{
        
    }, [costCenterData])

    const updateProductItemState = () => {
        if (items != null){
            const updatedItem = items.map((item) => {
                let existItem = productItems?.find(x => x.id === item.id)
                return { ...item, ...{checkItem: checkAll, budgetObject: existItem?.budgetObject, branchObject: existItem?.branchObject, budgetDisable: true } };
            });
            setProductItems(updatedItem);
            processSummary(updatedItem);
            if (updatedItem.filter(x => x.checkItem).length > 0)
                setCollapseKey(1);
            else
            setCollapseKey(0);
        }
    }

    const handleCostcenterChange = async (value: { value: string; label: React.ReactNode })=> {
        setBranchDataLoading(true);
        console.log(value.value);
        setCostcenterSelected(value);
        setCostcenterRequired(false);
        let budgetData = await getCostCenterBudget(value)
        
        //console.log(budgetData);
        //setCostCenterBudgetData(budgetData)
        if (budgetData !== undefined && budgetData.length > 0)
        {
            
            let _userGLoptions: { value: string; label: string }[] = [];

            _userGLoptions = budgetData.map((item: any) => ({
                value: item.GLAccountCode,
                label: item.GLAccountCode + ' - ' + item.GLAccountName
            }));

            const distinctGLOption = _userGLoptions?.map(c => ({ value : c.value, label : c.label }))
            .filter((c, index, self) => index === self.findIndex(p => p.value === c.value && p.label === c.label)); 

            setCostCenterBudget001Option(distinctGLOption.filter(v => v.value === '5109030010'));
            setCostCenterBudget002Option(distinctGLOption.filter(v => v.value === '5102050030'));
            setCostCenterBudget003Option(distinctGLOption.filter(v => v.value !== '5109030010' && v.value !== '5102050030'));


            //distinct internal order data
            const distinctInternalOrder = budgetData?.filter(i => i.IOCode !== '').map(c => ({ GLAccountCode : c.GLAccountCode, IOCode : c.IOCode, IOName : c.IOName }))
            .filter((c, index, self) => index === self.findIndex(p => p.GLAccountCode === c.GLAccountCode && p.IOCode === c.IOCode && p.IOName === c.IOName)); 
            setInternalOrderData(distinctInternalOrder);

           
            //check default value by category group
            let _productItem = productItems?.map(item => {
                if (item.categoryGroupCode === '001')
                {
                    let filterObject = budgetData.find(x => x.GLAccountCode === '5109030010');//ค่าเครื่องเขียน
            
                    item.budgetObject = filterObject;
                    item.budgetDisable = true;
                    item.internalOrderOption = processInternalOrderForDll(distinctInternalOrder, '5109030010')

                }else if (item.categoryGroupCode === '002'){
                    let filterObject = budgetData.find(x => x.GLAccountCode === '5102050030');//ค่าวัสดุคอมพิวเตอร์
            
                    item.budgetObject = filterObject;
                    item.budgetDisable = true;
                    item.internalOrderOption = processInternalOrderForDll(distinctInternalOrder, '5102050030')
                }else{
                    item.budgetDisable = false;
                    item.budgetObject = null;
                }
                return item;
            });
            setProductItems(_productItem); 
        }

        const distinctBranch = costCenterData?.filter(x => x.CenterCCC === value || x.DepartmentCode === value  ).map(c => ({ BranchCCC : c.BranchCCC, BranchCCCDesc : c.BranchCCCDesc }))
        .filter((c, index, self) => index === self.findIndex(p => p.BranchCCC === c.BranchCCC && p.BranchCCCDesc === c.BranchCCCDesc));  
    

        let branchData : { value: string; label: string }[] = [];

        branchData = distinctBranch?.map((item: any) => ({
            value: item.BranchCCC,
            label: item.BranchCCCDesc
        }));

        console.log(branchData);
        setBranchOption(branchData);
        setBranchDataLoading(false);
    }

    const processInternalOrderForDll = (source:any, GLAccountCode: any) => {
        let internalOrderOption: { value: string; label: string }[] = [];

        internalOrderOption = source?.filter(x => x.GLAccountCode === GLAccountCode).map((item: any) => ({
            value: item.IOCode,
            label: item.IOName
        }));

        return internalOrderOption;
    }

    const handleCostcenterChange2 = async (value: { value: string; label: React.ReactNode }) => {
        setBranchDataLoading(true);
        setCostcenterSelected(value);
        setCostcenterRequired(false);

         // 5️⃣ Branch lookup (filter once)
        const selectedValue = value;
        const branchMap = new Map<string, string>();
        for (const c of costCenterData || []) {
            if (c.CenterCCC === selectedValue || c.DepartmentCode === selectedValue) {
                if (!branchMap.has(c.BranchCCC)) {
                    branchMap.set(c.BranchCCC, c.BranchCCCDesc);
                }
            }
        }
        const branchData = Array.from(branchMap, ([value, label]) => ({ value, label }));
        setBranchOption(branchData);

        let budgetData = await getCostCenterBudget(value);
        if (budgetData === undefined) { budgetData = [];}
        // if (!budgetData?.length) {
        //     setBranchDataLoading(false);
        //     return;
        // }

        // 1️⃣ Use Map to deduplicate and group — faster + memory-efficient
            const glMap = new Map<string, string>();
            const internalOrderMap = new Map<string, { GLAccountCode: string; IOCode: string; IOName: string }>();
            const resultGLs: { value: string; label: string }[] = [];
            const resultIOs: any[] = [];

            for (const item of budgetData) {
                // Dedup GL
                if (!glMap.has(item.GLAccountCode)) {
                    const label = `${item.GLAccountCode} - ${item.GLAccountName}`;
                    glMap.set(item.GLAccountCode, label);
                    resultGLs.push({ value: item.GLAccountCode, label });
                }

                // Dedup Internal Orders
                if (item.IOCode) {
                    const ioKey = `${item.GLAccountCode}-${item.IOCode}`;
                    if (!internalOrderMap.has(ioKey)) {
                        internalOrderMap.set(ioKey, {
                            GLAccountCode: item.GLAccountCode,
                            IOCode: item.IOCode,
                            IOName: item.IOName,
                        });
                        resultIOs.push({
                            GLAccountCode: item.GLAccountCode,
                            IOCode: item.IOCode,
                            IOName: item.IOName,
                        });
                    }
                }
            }

            // 2️⃣ Pre-filter once (no triple filter)
            const gl5109030010 = resultGLs.find(v => v.value === '5109030010');
            const gl5102050030 = resultGLs.find(v => v.value === '5102050030');
            const otherGLs = resultGLs.filter(v => v.value !== '5109030010' && v.value !== '5102050030');

            setCostCenterBudget001Option(gl5109030010 ? [gl5109030010] : []);
            setCostCenterBudget002Option(gl5102050030 ? [gl5102050030] : []);
            setCostCenterBudget003Option(otherGLs);

            // 3️⃣ Internal Order Option generation (use pre-built map)
            const processInternalOrderForDll = (GLAccountCode: string) =>
                resultIOs
                    .filter(x => x.GLAccountCode === GLAccountCode)
                    .map(x => ({ value: x.IOCode, label: x.IOName }));

            // 4️⃣ Avoid multiple map() + find() → use single loop
            const updatedProducts = productItems?.map(item => {
                let matchedBudget, internalOrderOption;
                if (item.categoryGroupCode === '001' && gl5109030010) {
                    matchedBudget = budgetData.find(x => x.GLAccountCode === '5109030010');
                    internalOrderOption = processInternalOrderForDll('5109030010');
                    item = { ...item, budgetObject: matchedBudget, budgetDisable: true, internalOrderOption };
                } else if (item.categoryGroupCode === '002' && gl5102050030) {
                    matchedBudget = budgetData.find(x => x.GLAccountCode === '5102050030');
                    internalOrderOption = processInternalOrderForDll('5102050030');
                    item = { ...item, budgetObject: matchedBudget, budgetDisable: true, internalOrderOption };
                } else {
                    internalOrderOption = resultIOs
                        .filter(x => x.GLAccountCode !== '5109030010' && x.GLAccountCode !== '5102050030')
                        .map(x => ({ value: x.IOCode, label: x.IOName }));
                    item = { ...item, budgetDisable: false, budgetObject: null, internalOrderOption};
                }
                return item;
            });
            setProductItems(updatedProducts);
            setInternalOrderData(resultIOs);

            setBranchDataLoading(false);
    };




    const handleCostcenterBudgetChange = async (value: any, currentProductItem : any)=> {

        console.log(value);

        const newProductItem = [...productItems];

        let currentIndex = newProductItem.findIndex(x => x === currentProductItem);
        console.log(currentIndex);

        let filterObject = costCenterBudgetData.find(x => x.GLAccountCode === value);
        console.log(filterObject);
        currentProductItem.budgetObject = filterObject;
        currentProductItem.internalOrderObject = null;
        currentProductItem.internalOrderOption = processInternalOrderForDll(internalOrderData, value);

        newProductItem[currentIndex] = currentProductItem;

        setProductItems(newProductItem);
    }

    const handleInternalOrderChange = (value: any, options: any, currentProductItem : any, key: any) => {

        console.log(value);

        const newProductItem = [...productItems];

        let currentIndex = newProductItem.findIndex(x => x === currentProductItem);
        console.log(currentIndex);
        if (value != null)
        {
            currentProductItem.internalOrderObject = { IOCode : options.value, IOName : options.label };
        }else{
            currentProductItem.internalOrderObject = null
        }
        
        newProductItem[currentIndex] = currentProductItem;

        setProductItems(newProductItem);
    }
 

    const handleBranchChange = async (value: any, options: any, currentProductItem : any)=> {

        console.log(value);

        const newProductItem = [...productItems];

        let currentIndex = newProductItem.findIndex(x => x === currentProductItem);
        console.log(currentIndex);
        if (value != null)
        {
            currentProductItem.branchObject = { branchCode : options.value, branchName : options.label };
        }else{
            currentProductItem.branchObject = null
        }
        
        newProductItem[currentIndex] = currentProductItem;

        setProductItems(newProductItem);
    }


    // const getBudget = async () => {
       
    //     let year = moment().format('YYYY'); //GetFiscalYear();
    //     let budgetData = await GetBudget({ DepartmentId: userData.DepartmentId, BudgetYear:year});
    //     console.log(budgetData);
    //     setUserBudgetData(budgetData.data);
    //     if (budgetData.data !== undefined && budgetData.data.length > 0)
    //         {
                
    //             let _userBudgetOptions: { value: string; label: string }[] = [];
    
    //             _userBudgetOptions = budgetData.data.map((item: any) => ({
    //                 value: item.GLAccount,
    //                 label: item.GLAccountName
    //             }));
                
    //             setUserBudgetOption(_userBudgetOptions);
    
    //             //form.setFieldsValue({selectDeptId: _userBudgetOptions[0].value});
    //             setUserBudgetSelect(budgetData.data[0]);

    //         }
    // }

    const getCostcenter = async() => {
        setCostCenterDataLoading(true);

        let costCenterData : { value: string; label: string }[] = [];
        let listValue = await GetECatalogCostcenter({ EmployeeId: userData.EmployeeId, EmployeeCode:userData.EmployeeCode});
        //console.log(listValue.data);
        setCostCenterData(listValue.data);
        const distinctDepartment = listValue.data?.map(c => ({ DepartmentCode : c.DepartmentCode, DepartmentNameTh : c.DepartmentNameTh }))
            .filter((c, index, self) => index === self.findIndex(p => p.DepartmentCode === c.DepartmentCode && p.DepartmentNameTh === c.DepartmentNameTh));  
        
        console.log(distinctDepartment);
        setDepartmentData(distinctDepartment);


        distinctDepartment?.map(item => {
            costCenterData.push({
                value: item.DepartmentCode,
                label: item.DepartmentNameTh,
            })
        });

        const distinctCostCenter = listValue.data?.map(c => ({ CenterCCC : c.CenterCCC, CenterCCCDesc : c.CenterCCCDesc }))
            .filter((c, index, self) => index === self.findIndex(p => p.CenterCCC === c.CenterCCC && p.CenterCCCDesc === c.CenterCCCDesc));  
        
        console.log(distinctCostCenter);
        distinctCostCenter?.map(item => {
            let isExist = costCenterData.find(x => x.value === item.CenterCCC);
            if (!isExist){
                costCenterData.push({
                    value: item.CenterCCC,
                    label: item.CenterCCCDesc,
                })
            }
           
        });
        
        setCostCenterOption(costCenterData);
        
        //await getBudget();

        setCostCenterDataLoading(false);
    }

    const getCostCenterBudget = async(costcenterCode: string) => {
        let currentYear = moment().format('YYYY');
        let listValue = await GetCostcenterBudgetByCode({ BudgetYear: currentYear, CostcenterCode:costcenterCode});
        console.log(listValue.data);
        setCostCenterBudgetData(listValue.data);

        return listValue.data
    }


    const deleteFromCart = (itemdata: any) => {
        removeItem(itemdata.id);

        let itemExist = productItems.findIndex((x) => x.id === itemdata.id);
        if (itemExist > -1){
            productItems.splice(itemExist, 1);
            setProductItems(productItems);
        }

        notification.success({
            message: 'ลบรายการสำเร็จ',
            // description:
            //   'This is the content of the notification. This is the content of the notification. This is the content of the notification.',
            placement: "top",
        });

    }

    const getCategoryGroup = (isFilter: boolean) => {

        if (isFilter){
            const distinctGroupProduct = productItems?.filter(item => item.checkItem)?.map(product => ({ groupCode : product.categoryGroupCode, groupName : product.categoryGroupName }))
            .filter((product, index, self) => index === self.findIndex(p => p.groupCode === product.groupCode && p.groupName === product.groupName));  
            return distinctGroupProduct
        }else{
            const distinctGroupProduct = productItems?.map(product => ({ groupCode : product.categoryGroupCode, groupName : product.categoryGroupName }))
            .filter((product, index, self) => index === self.findIndex(p => p.groupCode === product.groupCode && p.groupName === product.groupName)); 
            return distinctGroupProduct
        }
    }

    const getVendorCategoryFromProduct = (isFilter: boolean) => {

        if (isFilter){
            const distinctVendor = productItems?.filter(item => item.checkItem)?.map(product => ({ vendorCode : product.vendorCode, vendorName : product.vendorName, groupCode : product.categoryGroupCode, groupName : product.categoryGroupName }))
            .filter((product, index, self) => index === self.findIndex(p => p.vendorCode === product.vendorCode && p.vendorName === product.vendorName && p.groupCode === product.groupCode && p.groupName === product.groupName));  
            return distinctVendor
        }else{
            const distinctVendor = productItems?.map(product => ({ vendorCode : product.vendorCode, vendorName : product.vendorName, groupCode : product.categoryGroupCode, groupName : product.categoryGroupName }))
            .filter((product, index, self) => index === self.findIndex(p => p.vendorCode === product.vendorCode && p.vendorName === product.vendorName && p.groupCode === product.groupCode && p.groupName === product.groupName)); 
            return distinctVendor
        }
       

    }

    const handleCheckAll: CheckboxProps['onChange']  = (evt:any) => {

        setCheckAll(!checkAll);
        UpdateStateItem(evt.target.checked, 0);

    }
    const handleCheckItem: CheckboxProps['onChange']  = (evt:any, id) => {

        UpdateStateItem(evt.target.checked, id);

    }

    function UpdateStateItem(isCheck: any, id: any){
        const updatedItem = productItems.map((item) => {
            if (id === 0){
                return { ...item, checkItem: isCheck };
            }else if (item.id === id) {
                return { ...item, checkItem: isCheck };
            }
            return item;

          });
          setProductItems(updatedItem);
          processSummary(updatedItem);
          if (updatedItem.filter(x => x.checkItem).length > 0)
            setCollapseKey(1);
          else
          setCollapseKey(0);
        return updatedItem;
    }

    function calculateTotal(price, quantity){
        return roundedUpWith2Digit(roundedUpWith2Digit(price * (100/107)) * quantity * (107/100));
     }
     const roundedUpWith2Digit = (value: number) => {
         return Math.round(value * 100) / 100;
     }
    const processSummary = (sourceData: any) => {
        // let _totalPrice = sourceData?.filter(item => item.checkItem).reduce((sum, current) => sum + (current.price * current.quantity), 0);
        // //let _totalPrice = sourceData?.filter(item => item.checkItem).reduce((sum, current) => sum + calculateTotal(current.price, current.quantity), 0);
        // let calculatePrice = _totalPrice * ((100 + 7) / 100)
        // let _vatPrice = calculatePrice - _totalPrice; //_totalPrice * (7 /107);
        // let _priceBeforeVat = _totalPrice * 100/107;
        // let _data: SummaryData = {
        //     TotalPrice: calculatePrice,
        //     TotalQuantity: sourceData?.filter(item => item.checkItem).reduce((sum, current) => sum + current.quantity, 0),
        //     TotalPriceNoVat: _totalPrice,// _priceBeforeVat, // _totalPrice - _vatPrice,
        //     VatPrice: _vatPrice
        // }
        let sumTotalPrice = 0;
        let sumCalculatePrice = 0;
        let sumVatPrice = 0;
        sourceData?.filter(item => item.checkItem).forEach(item => {
            //item.price = calculateTotal(item.price, item.quantity);
            let _itemTotalPrice = item.price * item.quantity;
            let _calPrice = _itemTotalPrice * ((100 + 7) / 100);

            sumTotalPrice += roundedUpWith2Digit(_itemTotalPrice);
            sumCalculatePrice += roundedUpWith2Digit(_calPrice);
            sumVatPrice +=  roundedUpWith2Digit(_calPrice - _itemTotalPrice);
        });

        let _data: SummaryData = {
            TotalPrice: sumCalculatePrice,
            TotalQuantity: sourceData?.filter(item => item.checkItem).reduce((sum, current) => sum + current.quantity, 0),
            TotalPriceNoVat: sumTotalPrice,// _priceBeforeVat, // _totalPrice - _vatPrice,
            VatPrice: sumVatPrice
        }

        setSummaryData(_data)
    }

    const handleOrderProduct = async ()=>{

        try{
            setLoadingsSendOrder(true);
            let templateCodeMaster = await GetMasterDataByTypeNames(["AUTOPR"]);
            let templateCode = "";
            if (templateCodeMaster.length > 0)
            {
                templateCode = templateCodeMaster[0].Value1;
            }else{
                setLoadingsSendOrder(false);
                return;
            }

            let templateForm = await GetWolfTemplate(templateCode);
            
            console.log("before", templateForm);
            //check column id
            // templateForm.form.map((ctrl) => {
            //     if (ctrl.template.label == "รายการ" && ctrl.template.type == "tb")
            //     {
            //         if (ctrl.template.attribute.column.filter(x => x.template.label === "id").length === 0){
            //             //console.log(ctrl.template.attribute);
            //             let columnId = {
            //                     data : {
            //                         value: null,
            //                         row: null
            //                     },
            //                     guid: generateQuickGuid(),
            //                     template: {
            //                         alter: "Hide control",
            //                         label: "id",
            //                         type: "t",
            //                         attribute: {
            //                             column: null,
            //                             required: false
            //                         }
            //                     }
            //             }
            //             ctrl.template.attribute.column.push(columnId);
            //         }
            //     }
            // })
    
            // console.log("after", templateForm);
    



            if (templateForm != null)
            {
                let objectTemplate = JSON.parse(JSON.stringify(templateForm));
               
                if (productItems?.length > 0){
                    
                    //const groupProduct = getCategoryGroup(true);
                    const vendorByProduct = getVendorCategoryFromProduct(true);
                    const objectTransaction = [];
                    let listOrderItem = [];
                    let documentNo = [];
                    //await Promise.all(vendorByProduct.map(async (gitem) => {
                        for (const gitem of vendorByProduct) {
                            
                            //let filterProduct = productItems?.filter(x => x.categoryGroupCode === gitem.groupCode)
                            let filterProduct = productItems?.filter(x => x.vendorCode === gitem.vendorCode && x.categoryGroupCode === gitem.groupCode)

                            let orderId = "PR-E000000" + new Date().toDateString();
                        
                            let requestObject = SetDataToObjectWolf(objectTemplate, filterProduct, gitem);
                            let returnData = await CreateMemorandum(requestObject);
                            if (returnData != null && returnData.data != undefined)
                            {
                                documentNo.push(returnData.data.documentNo);
                                let objectItem = {
                                    documentNo : returnData.data.documentNo,
                                    documentId : returnData.data.id,
                                    groupCode : gitem.groupCode,
                                    groupName : gitem.groupName
                                }

                                objectTransaction.push(objectItem);

                                filterProduct.map((item) => {

                                    let _vatPrice = item.price * (7 /107);//item.price * (7 /100);
                                    let _priceBeforeVat =  item.price * (100/107);//item.price - _vatPrice;
                                    
                                    let orderItem = {
                                        
                                        OrderID: orderId,
                                        MemoId: returnData.data.id,
                                        ItemID: item.id,
                                        OrderTotal: item.quantity,
                                        ItemPrice: item.price,
                                        ItemVat: _vatPrice,
                                        ItemBeforVat: _priceBeforeVat,
                                        CreatedBy: userData.EmployeeId.toString(),
                                        ModifiedBy: userData.EmployeeId.toString()
                                    };
                                    console.log(orderItem);
                                    listOrderItem.push(orderItem);
                                })
                            
                            }

                    //}))
                        }
                    //.then(async () => {

                        await InsertTransactionOrderitem(listOrderItem);

                        Swal.fire({
                            title: "ส่งข้อมูลขอซื้อสำเร็จ",
                            html: "<div>" + documentNo.toString()+"</div>",
                            //text: returnData.data.documentNo ,
                            icon: "success",
                            confirmButtonText: "ตกลง"
                        }).then((result) => {
                            /* Read more about isConfirmed, isDenied below */
                            if (result.isConfirmed) {

                                productItems?.map(x => {
                                    removeItem(x.id);
                                });
                                setOpenSummaryOrderPopup(false);
                                setLoadingsSendOrder(false);
                                //history.push(`/Default`);
                                window.location.href = "/Default";
                            } 
                        })
                    //})

                }


            }else{
                setLoadingsSendOrder(false);
            }
            
            //console.log("after" , templateForm);
        }catch(e){
            console.error("createError", e);
            setLoadingsSendOrder(false);
        }

        
    }
    
    function SetDataToObjectWolf(templateForm, _productItem, vendorBygroup){

        //let _totalPrice = _productItem?.filter(item => item.checkItem).reduce((sum, current) => sum + calculateTotal(current.price, current.quantity), 0);
        // let _totalPrice = _productItem?.filter(item => item.checkItem).reduce((sum, current) => sum + (current.price * current.quantity), 0);
        // let calculatePrice = _totalPrice * ((100 + 7) / 100)
        // let _vatPrice = calculatePrice - _totalPrice;//_totalPrice * (7 / 107);//item.price * (7 /100);
        // let _priceBeforeVat =  _totalPrice * (100/107);//item.price - _vatPrice;
        
        // let _summaryData: SummaryData = {
        //     TotalPrice: calculatePrice,
        //     TotalQuantity: _productItem?.filter(item => item.checkItem).reduce((sum, current) => sum + current.quantity, 0),
        //     TotalPriceNoVat: _totalPrice,//_totalPrice - _vatPrice,
        //     VatPrice: _vatPrice
        // }


        let sumTotalPrice = 0;
        let sumCalculatePrice = 0;
        let sumVatPrice = 0;
        _productItem?.filter(item => item.checkItem).forEach(item => {
            //item.price = calculateTotal(item.price, item.quantity);
            let _itemTotalPrice = item.price * item.quantity;
            let _calPrice = _itemTotalPrice * ((100 + 7) / 100);

            sumTotalPrice += roundedUpWith2Digit(_itemTotalPrice);
            sumCalculatePrice += roundedUpWith2Digit(_calPrice);
            sumVatPrice +=  roundedUpWith2Digit(_calPrice - _itemTotalPrice);
        });

        let _summaryData: SummaryData = {
            TotalPrice: sumCalculatePrice,
            TotalQuantity: _productItem?.filter(item => item.checkItem).reduce((sum, current) => sum + current.quantity, 0),
            TotalPriceNoVat: sumTotalPrice,// _priceBeforeVat, // _totalPrice - _vatPrice,
            VatPrice: sumVatPrice
        }

        let selectedCostCenter = costCenterOption.filter(x => x.value === costcenterSelected);

        let firstItem = _productItem?.filter(item => item.checkItem)[0];

        let userDept = departmentData[0];
        templateForm.form.map((_template) => {
          let setValue = null;
          switch (_template.template.label) {
            case "ประเภทสินค้าและงานบริการ":
                setValue = firstItem?.categoryType;
              break;
            case "วันที่ต้องการสินค้า/บริการ": 
                //setValue = moment().format("DD MMM YYYY")
                setValue = "";
              break;
            case "รหัสพนักงาน":
                setValue = userData.EmployeeCode;
                break;
            case "Email":
                setValue = userData.Email;
                break;
            case "ส่วนงาน":
                setValue = userDept?.DepartmentNameTh;
                break;   
            case "รหัสส่วนงาน":
                setValue = userDept?.DepartmentCode;
                break;
            case "ชื่องาน / โครงการ":
                //setValue = "ทดสอบ 11";
                break;        
            case "สถานที่จัดส่ง":
                //setValue = "-";
                break;
            case "เบอร์โทร":
                //setValue = "-";
                break;
            case "หมวดหมู่ของสินค้า":
                setValue = vendorBygroup.groupName;
                break;
            case "รหัสหมวดหมู่ของสินค้า":
                setValue = vendorBygroup.groupCode;
                break;
            case "ชื่อผู้ค้า":
                setValue = firstItem?.vendorName
              break;
            case "รหัสผู้ค้า":
                setValue = firstItem?.vendorCode
                break;
            case "เบอร์โทรผู้ค้า":
                setValue = firstItem?.vendorMobileNo;
                break;
            case "ที่อยู่ผู้ค้า":
                setValue = firstItem?.vendorAddress;
                break;
            case "เงื่อนไขการชำระเงิน":
                setValue = firstItem?.vendorPaymentCondition;
                break;
            case "วิธีการชำระเงิน":
                setValue = firstItem?.vendorPaymentMethod;
                break;
            case "รายการ":
              //     // set data as table to row array
              let rowItem = [];
              let filterItem = _productItem?.filter((item) => item.checkItem); //.reduce((sum, current) => sum + (current.price * current.quantity), 0)
              filterItem?.map((item) => {
                let subRowItem = [];

                //let _vatPrice = item.price * (7 /107);
                //let _priceBeforeVat = item.price * (100/107);//item.price - _vatPrice;
                let itemTotalPrice = (item.price * item.quantity);
                let calculatePrice = itemTotalPrice * ((100 + 7) / 100)
                let _vatPrice = calculatePrice - itemTotalPrice;
/*
                            case "งบประมาณ-ส่วนงาน":
                setValue = selectedCostCenter.length > 0 ? selectedCostCenter[0].label : null;
                break;
            case "รหัสงบประมาณส่วนงาน":
                setValue = selectedCostCenter.length > 0 ? selectedCostCenter[0].value : null;
                break;

*/



                subRowItem.push({ value: userData.EmployeeCode });//รหัสพนักงานในตาราง

                subRowItem.push({ value: selectedCostCenter.length > 0 ? selectedCostCenter[0].label : null });//งบประมาณ-ส่วนงาน
                subRowItem.push({ value: selectedCostCenter.length > 0 ? selectedCostCenter[0].value : null });//รหัสงบประมาณส่วนงาน
                subRowItem.push({ value: item.branchObject != null ?  item.branchObject?.branchName : null });//สาขา/ส่วนงาน
                subRowItem.push({ value: item.branchObject != null ?  item.branchObject?.branchCode : null });//รหัสส่วนงาน/สาขา

                //subRowItem.push({ value: userDept?.DepartmentCode });//รหัสส่วนงาน/สาขา
                subRowItem.push({ value: item.title }); //รายละเอียดสินค้า
                subRowItem.push({ value: item.budgetObject?.Budget_Year });//ปีงบประมาณ
                subRowItem.push({ value: item.budgetObject?.GLAccountName });//งบประมาณ
                subRowItem.push({ value: item.quantity.toString() }); //จำนวน
                subRowItem.push({ value: item.itemUnit }); //หน่วย
                subRowItem.push({ value: item.price.toString()  }); //ราคาต่อหน่วย // _priceBeforeVat.toFixed(2)
                subRowItem.push({value: roundedUpWith2Digit(item.price * item.quantity).toString()}); //จำนวนเงิน
                subRowItem.push({ value: item.internalOrderObject?.IOName });//Internal Order
                subRowItem.push({ value: item.internalOrderObject?.IOCode });//Internal Order Code 
                subRowItem.push({ value: "7" });//VAT
                subRowItem.push({ value: _vatPrice.toFixed(2) });//มูลค่าภาษี
                subRowItem.push({ value: roundedUpWith2Digit(calculatePrice).toString()  });//ราคารวมหลังภาษี calculateTotal(item.price, item.quantity).toString()
                subRowItem.push({ value: "บาท" });//สกุลเงิน
                subRowItem.push({ value: "1" });//อัตราแลกเปลี่ยน
                subRowItem.push({ value: roundedUpWith2Digit(item.price * item.quantity).toString() });//ราคาหลังอัตราแลกเปลี่ยน
                subRowItem.push({ value: roundedUpWith2Digit(calculatePrice).toString() });//ราคาหลังอัตราแลกเปลี่ยนรวมภาษี calculateTotal(item.price, item.quantity).toString()
                subRowItem.push({ value: item.budgetObject?.GLAccountCode });//GL Account Code
                subRowItem.push({ value: item.budgetObject?.AccountKOKJ });//AccountKOKJ
                subRowItem.push({ value: item.budgetObject?.AccountKOKJCon });//AccountKOKJCon
                subRowItem.push({ value: item.budgetObject?.PostKey });//PostKey
                subRowItem.push({ value: item.budgetObject?.ANBWA });//ANBWA
                subRowItem.push({ value: item.budgetObject?.NEWKO });//NEWKO
                subRowItem.push({ value: item.budgetObject?.NASSETS });//NASSETS
                subRowItem.push({ value: item.budgetObject?.ANLKL });//ANLKL
                subRowItem.push({ value: item.budgetObject?.PostKeyAA });//PostKeyAA
                subRowItem.push({ value: item.budgetObject?.NewkoAA });//NewkoAA
                subRowItem.push({ value: item.budgetObject?.ANBWAAA });//ANBWAAA
                subRowItem.push({ value: item.budgetObject?.NEWUM });//NEWUM
                subRowItem.push({ value: item.budgetObject?.Assetclass });//Assetclass
                subRowItem.push({ value: item.budgetObject?.AssetCode });//Assetcode
                subRowItem.push({ value: item.budgetObject?.assetgroup});//assetgroup
                subRowItem.push({ value: item.budgetObject?.GDLGRP });//GDLGRP
                subRowItem.push({ value: item.budgetObject?.MENGE });//MENGE
                subRowItem.push({ value: userData.EmployeeCode });//รหัสพนักงานในตาราง2
                // subRowItem.push({ value: selectedCostCenter.length > 0 ? selectedCostCenter[0].label : null });//สาขา / ส่วนงาน  //userDept?.DepartmentNameTh
                // subRowItem.push({ value: selectedCostCenter.length > 0 ? selectedCostCenter[0].label : null });//รหัสสาขา / ส่วนงาน //userDept?.DepartmentCode
              

                subRowItem.push({ value: generateQuickGuid() });//id
                subRowItem.push({ value: "O Opex" });//Account Assignment
                			
                //subRowItem.push({ value: item.itemId }); //รหัสสินค้า
                // subRowItem.push({ "value": _vatPrice.toFixed(2) });//ภาษีมูลค่าเพิ่มต่อหน่วย //_vatPrice.toString() NumberFormatter(_vatPrice)
                // subRowItem.push({ "value": _priceBeforeVat.toFixed(2) });//ราคาสินค้าต่อหน่วยก่อนภาษี //_priceBeforeVat.toString() NumberFormatter(_priceBeforeVat)

                rowItem.push(subRowItem);
              });
              _template.data.row = rowItem;
                break;
            case "จำนวนเงินรวม":
                setValue = _summaryData.TotalPriceNoVat.toFixed(2);
                break;
            case "อัตราภาษี":
                setValue = "7";
                break;
            case "ภาษีมูลค่าเพิ่ม":
                setValue = _summaryData.VatPrice.toFixed(2);
                break;
            case "จำนวนเงินทั้งสิ้น":
                setValue = _summaryData.TotalPrice.toFixed(2);
                break;
            case "รวมเงินแปลงเป็นบาท":
                setValue = _summaryData.TotalPriceNoVat.toFixed(2);
                break;
            case "รวมเงินแปลงเป็นบาทรวมภาษี":
                setValue = _summaryData.TotalPrice.toFixed(2);
                break;
            case "วันที่เปิดใบคำขอ": 
                //setValue = moment().format("DD MMM YYYY")
                setValue = "";
              break;
          }

          if (setValue != null) {
            _template.data.value = setValue;
          }
        });
        templateForm.userPrincipalName = userData.Email;
        templateForm.amount = _summaryData.TotalPrice.toFixed(2);
        // templateForm.subject =
        //   "ใบสรุปรายการขอซื้อ : " + userData.DepartmentNameTh;
        return templateForm;
    }


    
    const handleAddProduct = async () =>{

        if (addProductId != "")
        {
            setLoadingsAddProduct(true);
            const dataJson = {
                searchItem : "",
                Catagoly :0,
                ItemID: addProductId
              };
            let response = await SearchCatalogItem(dataJson);
            const data = response.data;
            if (data === null) {
                notification.error({
                    message: 'ไม่พบสินค้า',
                    // description:
                    //   'This is the content of the notification. This is the content of the notification. This is the content of the notification.',
                    placement: "top",
                });
                setLoadingsAddProduct(false);
                return
            }
            let productItem: IProductItem;
            let _tempProductItem: IProductItem[] = MapsDataToProductObject(data);
            productItem = _tempProductItem[0];
            addItem(productItem, 1);
            setAddProductId("");
            // const updatedItem = items.map((item) => {
            //     return { ...item, checkItem: checkAll };
            // });
            // setProductItems(updatedItem);
            // processSummary(updatedItem);
            // if (updatedItem.filter(x => x.checkItem).length > 0)
            //     setCollapseKey(1);
            // else
            // setCollapseKey(0);

            //console.log(totalUniqueItems);
            NotificationAddCartSuccess();
            setLoadingsAddProduct(false);
        }
      
    }
    const handleOpenRequest = async () => {

        setValidateClick(true);
        
        var validItem = productItems?.filter(item => item.checkItem && (item.budgetObject?.GLAccountCode === undefined || item.branchObject?.branchCode === undefined|| item.vendorName === null));
        
        console.log('Validated Values:', validItem);
        if (validItem?.length > 0)
        {
            //message.error("กร");

            return;
        }




        
       
        let showAlert = false;
        // if (userBudget != null)
        // {
        //     if (userBudget?.Remaining > summaryData?.TotalPrice){
        //         showAlert = false;
        //         setOpenSummaryOrderPopup(true);
        //     }
        // }
        if (costcenterSelected === undefined || costcenterSelected == "" || costcenterSelected == " " )
        {
            showAlert = true;
            setCostcenterRequired(true);
        }else{
            setOpenSummaryOrderPopup(true);
        }

        console.log(costcenterSelected);

        if (showAlert)
        {
            // Swal.fire({
            //     title: "วงเงินคงเหลือไม่เพียงพอ",
            //     icon: "warning",
            //     confirmButtonText: "ตกลง"
            //   }).then((result) => {
            //     /* Read more about isConfirmed, isDenied below */
            //     if (result.isConfirmed) {
            //       setOpenSummaryOrderPopup(false);
            //     } 
            //   })


            // notification.error({
            //     message: 'Require field.',
            //     description: 'งบประมาณ-ส่วนกลาง is required.',
            //     placement: "topRight",
            //     icon: <SmileOutlined style={{ color: '#108ee9' }} />,
            // });
            toggleAlert({
                message: `Require field.`,
                description: `งบประมาณ-ส่วนกลาง is required.`,
                type: "error",
              });
        }

        
    }
    const ProductItemPart = () => {
        const groupProduct = getCategoryGroup(false);
        
        return (
            <>
                {
                    groupProduct?.map((group, gindex) => (
                        <>
                        <div className="cart-shop-header" style={ gindex !== 0 ? { marginTop: "15px"  } : { }}>
                            <div className="cart-shop-detail">
                                {/* <div className="cart-shop-detail-checkbox">
                                    <Checkbox></Checkbox>
                                </div> */}
                                <div className="cart-shop-detail-title" style={{fontSize: "16px"}}>
                                { group.groupName }
                                </div>
                            </div>
                        </div>
                            {
                                <Form
                                form={form}
                                // onFinish={onFinish}
                                // onFinishFailed={onFinishFailed}
                                layout="vertical"
                              >
                                {
                                        productItems?.filter(x => x.categoryGroupCode === group.groupCode).map((item, index) => (

                                            <>
                                                <div key={item.id} className="cart-item-row">
                                                    <div className="cart-item-col">
                                                        <div className="cart-item-col-checkbox">
                                                            <Checkbox checked={item.checkItem} onChange={(e) => { handleCheckItem(e, item.id)}}></Checkbox>
                                                        </div>
                                                        <div className="cart-item-col-product">
                                                            <div className="cart-item-col-product-detail">
                                                                {
                                                                    item.thumbnail != null ? (
                                                                    <a title={item.title} href={`/productdetail?productid=${item.itemId}`} >
                                                                        <img className="cart-item-col-product-image" src={item.defaultthumbnail } alt="product img"></img>
                                                                        {/* item.thumbnail[0].ItemPicPath */}
                                                                    </a>
                                                                    ) : (<></>)
                                                                }
            
                                                                <div className="cart-item-col-product-title">
                                                                    <a className="cart-item-col-product-title-link" title={item.title} href={`/productdetail?productid=${item.itemId}`} >
                                                                        {item.title}
                                                                    </a>
                                                                    <div>
                                                                        <div style={{fontSize: "14px"}}>รหัสสินค้า : {item.itemId}</div>
                                                                        {item.description}
                                                                    </div>
                                                                </div>
                                                            </div>
            
                                                        </div>
            
                                                        <div className="cart-item-col-budgetcode px-1">
                                                        
                                                        <Select className="budget-select-dll" key={"department"}
                                                            allowClear
                                                            showSearch
                                                            placeholder="เลือกรหัสงบประมาณ"
                                                            optionFilterProp="children"
                                                            filterOption={(input, option) => (option?.label.toLowerCase() ?? '').includes(input.toLowerCase())}
                                                            filterSort={(optionA, optionB) =>
                                                                (optionA?.label ?? '').toLowerCase().localeCompare((optionB?.label ?? '').toLowerCase())
                                                            }
                                                            options={item.categoryGroupCode === "001" ? costCenterBudget001Option : item.categoryGroupCode === "002" ? costCenterBudget002Option : costCenterBudget003Option}
                                                            //options={ddlOption}
                                                            disabled={item.budgetDisable ? item.budgetDisable : false}
                                                            onChange={e => handleCostcenterBudgetChange(e, item)}
                                                            value={item.budgetObject?.GLAccountCode}
                                                            dropdownClassName="dropdown-list-popup"
                                                            status={item.budgetObject?.GLAccountCode === undefined && validateClick && item.checkItem  ? 'error' : ''}
                                                            />
                                                          {item.budgetObject?.GLAccountCode === undefined && validateClick && item.checkItem  && (
                                                                <div style={{ color: 'red', marginTop: 4 }}>กรุณาเลือกรหัสงบประมาณ</div>
                                                            )}
                                                        </div>
                                                        <div className="cart-item-col-internalorder px-1">
                                                               {/* {  item.budgetObject ? item.budgetObject?.IOName : '' } */}
            
                                                               <Select className="budget-select-dll" key={`internalOrder-${item.id}-${item.budgetObject?.GLAccountCode}`}
                                                                    allowClear
                                                                    showSearch
                                                                    placeholder="เลือก Internal Order"
                                                                    optionFilterProp="children"
                                                                    filterOption={(input, option) => (option?.label.toLowerCase() ?? '').includes(input.toLowerCase())}
                                                                    filterSort={(optionA, optionB) =>
                                                                        (optionA?.label ?? '').toLowerCase().localeCompare((optionB?.label ?? '').toLowerCase())
                                                                    }
                                                                    options={item.internalOrderOption}
                                                                    value={item.internalOrderObject?.IOCode ?? undefined}
                                                                    onChange={(e, option) => handleInternalOrderChange(e, option, item, item.id)}
                                                                    dropdownClassName="dropdown-list-popup"
                                                                    loading={branchDataLoading}
                                                                    />
            
                                                            </div>
                                                        <div className="cart-item-col-budget px-1">
                                                        {  
                                                           item.budgetObject ? NumberFormatter(item.budgetObject?.Amount) : NumberFormatter(0)
                                                        }
                                                        </div>
                                                        <div className="cart-item-col-branch px-1">
                                                        
                                                             <Select className="budget-select-dll" key={"branch"}
                                                            allowClear
                                                            showSearch
                                                            placeholder="เลือกสาขา"
                                                            optionFilterProp="children"
                                                            filterOption={(input, option) => (option?.label.toLowerCase() ?? '').includes(input.toLowerCase())}
                                                            filterSort={(optionA, optionB) =>
                                                                (optionA?.label ?? '').toLowerCase().localeCompare((optionB?.label ?? '').toLowerCase())
                                                            }
                                                            options={branchOption}
                                                            onChange={(e, option) => handleBranchChange(e, option, item)}
                                                           dropdownClassName="dropdown-list-popup"
                                                           loading={branchDataLoading}
                                                           status={item.branchObject?.branchCode === undefined && validateClick && item.checkItem  ? 'error' : ''}
                                                            />
                                                            {item.branchObject?.branchCode === undefined && validateClick && item.checkItem && (
                                                                <div style={{ color: 'red', marginTop: 4 }}>กรุณาเลือกสาขา</div>
                                                            )}

                                                       
                                                        </div>
                                                        
                                                        <div className="cart-item-col-seller px-1">
                                                        { item.vendorName }
                                                        { (item.vendorName === undefined || item.vendorName === null || item.vendorName === '') && validateClick && item.checkItem && (
                                                                <div style={{ color: 'red', marginTop: 4 }}>ไม่มีข้อมูลบริษัท</div>
                                                            )}
                                                        </div>
                                                        <div className="cart-item-col-price">
                                                            {/* {item.price.toFixed(2)} */}
                                                            { NumberFormatter(item.price) }
                                                        </div>
                                                        <div className="cart-item-col-qty">
                                                            <div style={{ display: "flex", alignItems: "center"}}>
            
                                                                <button className="product-qty-btn btnDecrease" onClick={() => {
                                                                    let itemQuantity = item.quantity - 1;
                                                                    updateItemQuantity(item.id, itemQuantity);
                                                                    const updateCart = productItems.map((_item) => {
                                                                        if (_item.id === item.id) {
                                                                          return {..._item, quantity: itemQuantity};
                                                                        }
                                                                        return _item;
                                                                    });
            
                                                                    setProductItems(updateCart);
            
                                                                }}>-</button>
                                                                {/* <input className="product-qty-btn txtInput" type="text" readOnly role="spinbutton" aria-live="assertive" defaultValue={item.quantity} value={item.quantity}></input> */}
                                                                <input className="product-qty-btn txtInput" type="number" min={1} role="spinbutton" aria-live="assertive" defaultValue={item.quantity} value={item.quantity}  onChange={e => {
                                                                    if (e.target.value != "" && e.target.value != "0" && e.target.value.indexOf('-') < 0){
                                                                        let itemQuantity = parseInt(e.target.value)
                                                                        updateItemQuantity(item.id, itemQuantity)
                                                                        const updateCart = productItems.map((_item) => {
                                                                            if (_item.id === item.id) {
                                                                            return {..._item, quantity: itemQuantity};
                                                                            }
                                                                            return _item;
                                                                        });
            
                                                                        setProductItems(updateCart);
                                                                    }
                                                                    else
                                                                    {
                                                                        updateItemQuantity(item.id, 1)
                                                                        const updateCart = productItems.map((_item) => {
                                                                            if (_item.id === item.id) {
                                                                            return {..._item, quantity: 1};
                                                                            }
                                                                            return _item;
                                                                        });
            
                                                                        setProductItems(updateCart);
                                                                    }
                                                                }}  ></input>
                                                                <button className="product-qty-btn btnIncrease" onClick={() => {
                                                                     let itemQuantity = item.quantity + 1;
                                                                    updateItemQuantity(item.id, item.quantity + 1)
                                                                    const updateCart = productItems.map((_item) => {
                                                                        if (_item.id === item.id) {
                                                                          return {..._item, quantity: itemQuantity};
                                                                        }
                                                                        return _item;
                                                                      });
            
                                                                    setProductItems(updateCart);
                                                                }}>+</button>
                                                            </div>
                                                        </div>
                                                        <div className="cart-item-col-unit">
                                                            { item.itemUnit }
                                                        </div>
                                                        <div className="cart-item-col-totalprice" >
                                                            { 
                                                            NumberFormatter(item.price * item.quantity) 
                                                            //NumberFormatter(calculateTotal(item.price, item.quantity))
                                                            }
                                                        </div>
                                                        <div className="cart-item-col-action">
                                                            <BsTrash onClick={() => deleteFromCart(item)} />
                                                        </div>
                                                    </div>
                                                        </div>
                                            {
                                                index != -1 ? (
                                                <div className="cart-item-row-line"></div>
                                                ) : (<></>)
                                            }
                                            </>
            
                                         ))



                                }

                              </Form>

                               
                            }
                        </>
                        
                    ))

                }
            </>
        )

    }

    const ProductItemPartModal = () => {
       
        const groupProduct = getCategoryGroup(true);
        return (
            <>
                {
                    groupProduct?.map((group, gindex) => (
                        <>
                            <div className="cart-shop-header" style={ gindex !== 0 ? { marginTop: "15px"  } : { }}>
                                <div className="cart-shop-detail">
                                    <div className="cart-shop-detail-title" style={{fontSize: "16px"}}>
                                    { group.groupName }
                                    </div>
                                </div>
                            </div>
                            {
                                productItems?.filter(item => item.checkItem && item.categoryGroupCode === group.groupCode)?.map((item, index) => (

                                    <>
                                        <div key={item.id} className="cart-item-row">
                                            <div className="cart-item-col">
                                                
                                                <div className="cart-item-col-product">
                                                    <div className="cart-item-col-product-detail">
                                                        {
                                                            item.thumbnail != null ? (
                                                            <a title={item.title} href={`/productdetail?productid=${item.itemId}`} >
                                                                <img className="cart-item-col-product-image" src={item.defaultthumbnail } alt="product img"></img>
                                                                {/* item.thumbnail[0].ItemPicPath */}
                                                            </a>
                                                            ) : (<></>)
                                                        }
                    
                                                        <div className="cart-item-col-product-title">
                                                            <a className="cart-item-col-product-title-link" title={item.title} href={`/productdetail?productid=${item.itemId}`} >
                                                                {item.title}
                                                            </a>
                                                            <div>
                                                                <div style={{fontSize: "14px"}}>รหัสสินค้า : {item.itemId}</div>
                                                                {item.description}
                                                            </div>
                                                        </div>
                                                    </div>
                    
                                                </div>
                                                <div className="cart-item-col-budgetcode px-1">
                                                    {  item.budgetObject ? item.budgetObject?.GLAccountCode + ' - ' + item.budgetObject?.GLAccountName : '' }
                                                </div>
                                                <div className="cart-item-col-internalorder px-1">
                                                    {  item.internalOrderObject ? item.internalOrderObject?.IOName : '' }
                                                </div>
                                                <div className="cart-item-col-budget px-1">
                                                {  
                                                    item.budgetObject ? NumberFormatter(item.budgetObject?.Amount) : NumberFormatter(0)
                                                }
                                                </div>
                                                <div className="cart-item-col-branch px-1">
                                                    { item.branchObject ? item.branchObject?.branchCode + ' - ' + item.branchObject?.branchName : '' }
                                                </div>



                                                <div className="cart-item-col-seller">
                                                { item.vendorName }
                                                </div>
                                                <div className="cart-item-col-price">
                                                    {/* {item.price.toFixed(2)} */}
                                                    { NumberFormatter(item.price) }
                                                </div>
                                                <div className="cart-item-col-qty">
                                                    { item.quantity }
                                                </div>
                                                <div className="cart-item-col-unit">
                                                    { item.itemUnit }
                                                </div>
                                                <div className="cart-item-col-totalprice">
                                                    {
                                                    NumberFormatter(item.price * item.quantity) 
                                                    //NumberFormatter(calculateTotal(item.price, item.quantity))
                                                    }
                                                </div>
                                            </div>
                                        </div>
                            {
                                index != -1 ? (
                                <div className="cart-item-row-line"></div>
                                ) : (<></>)
                            }
                                    </>
                    
                                 ))
                            }
                        </>

                    ))
                }
            </>



            


        )
    }

   

    return isAuthorize ? (

        <Layout className="layout">
            <ECatalogNavigation />
            <Content style={{ padding: "0 10px" }}>
                {isCardLoading && (
                    <div className="logo-loading">
                        <img src={props.responeConfig?.pathLoading} alt="loading..." />
                    </div>
                )}
                <div className="cart-layout-content container-fluid mt-2">
                    {/* <Breadcrumb style={{ margin: "16px 0" }}>
                        <Breadcrumb.Item href="/">Home</Breadcrumb.Item>
                        <Breadcrumb.Item href="/ECatalog">E-Catalog</Breadcrumb.Item>
                        <Breadcrumb.Item>Cart </Breadcrumb.Item>

                    </Breadcrumb> */}
                    <Space direction="horizontal" style={{marginBottom:"15px"}}>
                        <div style={{border:"1px solid grey", borderRadius:"5px", minWidth: "300px", padding:"5px 10px"}}>
                            <Form layout="horizontal" className="cart-budget-form" >
                                <Form.Item label={"งบประมาณ-ส่วนกลาง"} name={"selectDeptId"}>
                                <Select className="auto_control_backdate" key={"department"}

                                showSearch
                                placeholder="เลือกงบประมาณ-ส่วนกลาง"
                                optionFilterProp="children"
                                filterOption={(input, option) => (option?.label.toLowerCase() ?? '').includes(input.toLowerCase())}
                                filterSort={(optionA, optionB) =>
                                    (optionA?.label ?? '').toLowerCase().localeCompare((optionB?.label ?? '').toLowerCase())
                                }
                                options={costCenterOption}
                                onChange={handleCostcenterChange2}
                                loading={costCenterDataLoading}
                                status={costcenterRequired ? "error" : ""}
                                dropdownClassName="dropdown-list-popup"
                            />
                                </Form.Item>
                            </Form>
                        </div>
                    </Space>
                    <div className="cart-header">
                            <div className="cart-header-col-checkbok">
                                {/* <label class="stardust-checkbox">
                                    <input class="stardust-checkbox__input" type="checkbox" aria-checked="false" aria-disabled="false" tabindex="0" role="checkbox" aria-label="Click here to select all products">
                                    <div class="stardust-checkbox__box"></div></label> */}
                                    <Checkbox checked={checkAll} onChange={handleCheckAll}></Checkbox>
                            </div>
                            <div className="cart-header-col-product">สินค้า</div>
                            <div className="cart-header-col-budgetcode">รหัสงบประมาณ</div>
                            <div className="cart-header-col-internalorder">Internal Order</div>
                            <div className="cart-header-col-budget">วงเงินคงเหลือ</div>
                            <div className="cart-header-col-branch">สาขา/ส่วนงาน</div>
                            <div className="cart-header-col-seller">บริษัท</div>
                            <div className="cart-header-col-price">ราคา/ชิ้น</div>
                            <div className="cart-header-col-qty">จำนวน</div>
                            <div className="cart-header-col-unit">หน่วยนับ</div>
                            <div className="cart-header-col-totalprice">ราคารวม</div>
                            <div className="cart-header-col-action">แอคชั่น</div>
                    </div>
                    <section className="cart-by-shop">
                        {/* <div className="cart-shop-header" style={{display: "none"}}>
                            <div className="cart-shop-detail">
                                <div className="cart-shop-detail-checkbox">
                                    <Checkbox></Checkbox>
                                </div>
                                <div className="cart-shop-detail-title">
                                    XXX
                                </div>
                            </div>
                        </div> */}
                        {
                            <section className="cart-item-detail">
                                {
                                    ProductItemPart()
                                        
                                    }


                                </section>

                        }


                    </section>
                    <section className="cart-to-dept">

                    </section>
                    <section className="cart-summarytotal">
                        <div className="cart-item-row" style={{marginTop:"10px", marginBottom: "10px"}}>
                            <div className="cart-item-col">
                                <div className="cart-item-col-checkbox">
                                </div>

                                <div className="cart-item-col-product">
                                    ราคาสุทธิ
                                </div>
                                <div className="cart-item-col-budgetcode"></div>
                                <div className="cart-item-col-internalorder"></div>
                                <div className="cart-item-col-budget"></div>
                                <div className="cart-item-col-branch"></div>
                                <div className="cart-item-col-seller"></div>
                                <div className="cart-item-col-price">

                                </div>
                                <div className="cart-item-col-qty">
                                    {/* {
                                        productItems?.filter(item => item.checkItem).reduce((sum, current) => sum + current.quantity, 0)
                                    } */}
                                    { summaryData?.TotalQuantity }
                                </div><div className="cart-item-col-unit">
                                    
                                </div>
                                <div className="cart-item-col-totalprice">
                                    {/* {
                                        (productItems?.filter(item => item.checkItem).reduce((sum, current) => sum + (current.price * current.quantity), 0))?.toFixed(2)
                                    } */}
                                     { NumberFormatter(summaryData?.TotalPriceNoVat) }
                                </div>
                                <div className="cart-item-col-action">

                                </div>
                                </div>
                        </div>

                    </section>
                    <Collapse collapsible="header"  className="cart-to-dept" expandIconPosition="end" activeKey={collapseKey} style={{ display: "none"}}
                    onChange={() => { collapseKey == 0 ? setCollapseKey(1) : setCollapseKey(0); }}>
                        <Panel header="ระบุชื่อผู้รับสินค้า และสถานที่รับสินค้า" key="1" style={{backgroundColor: "#c95558"}}>
                        <Row gutter={[8, 8]}>
                            <Col span={8} >
                                ระบุชื่อผู้รับสินค้า
                                <Select options={receiverAddressOption} onChange={(value: { value: string; label: React.ReactNode }) => {
                                    console.log(value);

                                    let filterSelect = receiverAddress.find((item) => item.receiverName === value);
                                    if (filterSelect != undefined){
                                        let defaultReceive : FormReceiveProps = {
                                            ReceiveName: filterSelect.receiverName,
                                            Telephone: filterSelect.TelMobile,
                                            ReceiveDate: "",
                                            ReceiveLocation: filterSelect.receiverAddress,
                                            EmployeeCode: filterSelect.EmployeeCode
                                        }
                                        setFormReceive(defaultReceive);
                                    }


                                    setFormReceive(formReceive => ({ ...formReceive, ReceiveName: value }))
                                    }} value={formReceive?.ReceiveName}
                                />
                            </Col>
                            <Col span={8}>
                                เบอร์โทรศัพท์
                                <Input onChange={(e) =>  setFormReceive(formReceive => ({ ...formReceive, Telephone: e.target.value }))} value={formReceive?.Telephone} />
                            </Col>
                            <Col span={8}>
                                วันส่งมอบ
                                <Input disabled={true} value={"ตามเงื่อนไขวันที่ส่งมอบในสัญญา"} />
                            
                                {/* <DatePicker onChange={(date: any, dateString: string) => {
                                    //console.log(date);
                                     setFormReceive(formReceive => ({ ...formReceive, ReceiveDate: date }))
                                }} /> */}
                            </Col>
                            <Col span={24}>
                                สถานที่จัดส่งสินค้า
                                <TextArea rows={4} onChange={(e) => {
                                     setFormReceive(formReceive => ({ ...formReceive, ReceiveLocation: e.target.value }))
                                }} value={formReceive?.ReceiveLocation} />
                            </Col>
                        </Row>

                        
                        </Panel>
                    </Collapse>
                    <section className="cart-total" style={{paddingBottom: "15px"}}>
                        <div className="cart-total-checkout container-fluid">
                            <div className="row">
                                <div className="col-6 cart-total-label">ราคาสุทธิสินค้าไม่รวมภาษี</div>
                                <div className="col-6 cart-total-content">
                                { NumberFormatter(summaryData?.TotalPriceNoVat) } บาท
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-6 cart-total-label">ภาษีมูลค่าเพิ่ม 7%</div>
                                <div className="col-6 cart-total-content">
                                    { NumberFormatter(summaryData?.VatPrice) } บาท
                                </div>
                            </div>
                            <div className="row mt-2">
                                <div className="col-6 cart-total-label" style={{color: "#ff0000", fontSize: "20px"}}>จำนวนรวมทั้งสิ้น</div>
                                <div className="col-6 cart-total-content" style={{color: "#ff0000", fontSize: "20px"}}>
                                    { NumberFormatter(summaryData?.TotalPrice) } บาท
                                </div>
                            </div>
                            <div className="row mt-2">
                                <div className="col-12 text-right"  style={{textAlign: "right"}}>
                                <Button type="primary" htmlType="button" className="cart-action-buy-button" onClick={() => handleOpenRequest()} disabled={
                                    productItems?.filter(item => item.checkItem).length > 0 ? false : true
                                }>
                                    ส่งขออนุมัติสั่งซื้อ
                                </Button>
                                {/* <button className="btn btn-danger btn-sm">ส่งขออนุมัติสั่งซื้อ</button> */}
                                </div>
                            </div>
                        </div>
                    </section>
                </div>
                <Modal
                    title="สรุปรายการขอซื้อสินค้า"
                    centered
                    visible={openSummaryOrderPopup}
                    //onOk={() => setOpenSummaryOrderPopup(false)}
                    //onCancel={() => setOpenSummaryOrderPopup(false)}
                    //width={1100}
                    closable={false}
                    maskClosable={false}
                    className="cart-summary-modal"
                    footer={[
                        <Button key="modalback" className="cart-modal-btn btn-not-accept" onClick={() => setOpenSummaryOrderPopup(false)} disabled={loadingsSendOrder}>
                          ไม่ยืนยัน
                        </Button>,
                        <Button key="modalsubmit" className="cart-modal-btn btn-accept" type="primary" loading={loadingsSendOrder} onClick={() => handleOrderProduct()}>
                          ยืนยัน
                        </Button>
                      ]}
                >
                    <div className="cart-header">
                            
                            <div className="cart-header-col-product">สินค้า</div>
                            <div className="cart-header-col-budgetcode">รหัสงบประมาณ</div>
                            <div className="cart-header-col-internalorder">Internal Order</div>
                            <div className="cart-header-col-budget">วงเงินคงเหลือ</div>
                            <div className="cart-header-col-branch">สาขา/ส่วนงาน</div>
                            <div className="cart-header-col-seller">บริษัท</div>
                            <div className="cart-header-col-price">ราคา/ชิ้น</div>
                            <div className="cart-header-col-qty">จำนวน</div>
                            <div className="cart-header-col-unit">หน่วยนับ</div>
                            <div className="cart-header-col-totalprice">ราคารวม</div>
                    </div>
                    <section className="cart-item-detail">
                                {
                                         ProductItemPartModal()
                                    }


                                </section>
                     <section className="cart-summarytotal">
                        <div className="cart-item-row" style={{marginTop:"10px", marginBottom: "10px"}}>
                            <div className="cart-item-col">

                                <div className="cart-item-col-product">
                                    ราคาสุทธิ
                                </div>
                                <div className="cart-item-col-budgetcode">

                                </div>
                                <div className="cart-item-col-internalorder">

                                </div>
                                <div className="cart-item-col-budget">

                                </div>
                                <div className="cart-item-col-branch">

                                </div>
                                <div className="cart-item-col-seller">

                                </div>
                                <div className="cart-item-col-price">

                                </div>
                                <div className="cart-item-col-qty">
                                    {/* {
                                        productItems?.filter(item => item.checkItem).reduce((sum, current) => sum + current.quantity, 0)
                                    } */}
                                    { summaryData?.TotalQuantity } 
                                </div>
                                <div className="cart-item-col-unit">
                                    
                                </div>
                                <div className="cart-item-col-totalprice" style={{ justifyContent: "flex-end"}}>
                                    {/* {
                                        (productItems?.filter(item => item.checkItem).reduce((sum, current) => sum + (current.price * current.quantity), 0))?.toFixed(2)
                                    } */}
                                     { NumberFormatter(summaryData?.TotalPriceNoVat) }
                                </div>
                                </div>
                        </div>

                    </section>
                    <section >
                        <div className="container" style={{ paddingRight: "20px"}}>
                            <div className="row">
                                <div className="col-6 cart-total-label">ราคาสุทธิสินค้าไม่รวมภาษี</div>
                                <div className="col-6 cart-total-content">
                                { NumberFormatter(summaryData?.TotalPriceNoVat) } บาท
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-6 cart-total-label">ภาษีมูลค่าเพิ่ม 7%</div>
                                <div className="col-6 cart-total-content">
                                    { NumberFormatter(summaryData?.VatPrice) } บาท
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-6 cart-total-label-red">จำนวนรวมทั้งสิ้น</div>
                                <div className="col-6 cart-total-content-red">
                                    { NumberFormatter(summaryData?.TotalPrice) } บาท
                                </div>
                            </div>
                        </div>
                    </section>
                    {/* <section className="container mt-4 px-4" style={{fontSize: "16px", fontWeight: "600"}}>
                        <div className="row">
                            <div className="col-2">ชื่อผู้รับสินค้า :</div>
                            <div className="col-4" style={{fontWeight: "normal"}}>
                                {formReceive?.ReceiveName}
                            </div>
                            <div className="col-2">เบอร์โทร :</div>
                            <div className="col-4" style={{fontWeight: "normal"}}>
                                { formReceive?.Telephone}
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-2">สถานที่จัดส่งสินค้า :</div>
                            <div className="col-10" style={{fontWeight: "normal"}}>
                                {formReceive?.ReceiveLocation}
                            </div>
                        </div>
                    </section> */}
                </Modal>
            </Content>
        </Layout>
    ) : (  <UnAurthorization/>);
};